import { createParser, parseAsString } from 'nuqs';
import { useQueryStateFixed } from '@Utils/nuqs-fix';
import type { FlowViewMode, GuestDetailsTab } from '../types';

const VALID_VIEW_MODES: FlowViewMode[] = ['flow', 'detailed'];
/** The tabs the flow page's guest details render. */
export const FLOW_GUEST_TABS: GuestDetailsTab[] = [
  'overview',
  'activity',
  'messages',
];

const parseAsViewMode = createParser<FlowViewMode>({
  parse: (v) =>
    VALID_VIEW_MODES.includes(v as FlowViewMode) ? (v as FlowViewMode) : null,
  serialize: (v) => v,
  eq: (a, b) => a === b,
}).withDefault('flow');

const parseAsGuestTab = createParser<GuestDetailsTab>({
  parse: (v) =>
    FLOW_GUEST_TABS.includes(v as GuestDetailsTab)
      ? (v as GuestDetailsTab)
      : null,
  serialize: (v) => v,
  eq: (a, b) => a === b,
}).withDefault('overview');

export function useFlowSearchParams() {
  const [stage, setStage] = useQueryStateFixed<string>('stage', parseAsString);
  const [view, setView] = useQueryStateFixed<FlowViewMode, FlowViewMode>(
    'view',
    parseAsViewMode,
  );
  const [guestTab, setGuestTab] = useQueryStateFixed<
    GuestDetailsTab,
    GuestDetailsTab
  >('guestTab', parseAsGuestTab);

  return { stage, setStage, view, setView, guestTab, setGuestTab };
}
